module.exports = {
      id: "greenway-logo-usage",
      viewBox: "0 0 512 94",
      url: __webpack_public_path__ + "images/sprites/brand.svg#greenway-logo-usage",
      toString: function () {
        return this.url;
      }
    }